exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".services-col-12{\r\n\theight:100%;\r\n\tpadding: 16px;\r\n\tbackground-color: white;\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 0 2px 4px 2px #B3B3B3;\r\n}\r\n.services-table{\r\n\tborder: none;\r\n\twidth: 100%;\r\n}\r\n.services-container{\r\n\tmargin-top: 16px;\r\n}\r\n.services-row{\r\n\twidth: 100%;\r\n}\r\n.services-sub-row{\r\n\twidth: 100%;\r\n\tmargin-left: auto;\r\n\tmargin-right: auto;\r\n}\r\n.services-col-6{\r\n\tpadding:0;\r\n\theight: 100%;\r\n}\r\n.services-ul{\r\n\tfont-size: 12pt;\r\n\theight: 100%;\r\n}\r\n.services-sub-col-6{\r\n\tpadding: 16px;\r\n\theight:100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/GitHub/gvrogers/src/app/styles/services.component.css
// module id = ../../../../../src/app/styles/services.component.css
// module chunks = 1